import { __awaiter, __generator } from "tslib";
import { DocumentData, OfflineData } from '@tencent/ark-model';
import { DocumentDataStorage, OfflineDataStorage } from '@tencent/ark-storage';
import { TransactionMode } from '@tencent/memoire-structured-storage';
import { LoggerProxy } from '../logger/logger-proxy';
var AbstractOfflineDataUpdater = /** @class */ (function () {
    function AbstractOfflineDataUpdater() {
    }
    /**
     * 更新未提交数据为已提交数据
     * 分两步走 1、删除本地未提交的数据 2、写入后台给的提交成功后的数据
     * @param param 更新相关的参数
     * @param commitResult 批量提交返回的结果
     * @param storageManager 数据库操作
     */
    Object.defineProperty(AbstractOfflineDataUpdater.prototype, "updateUncommittedData", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (param, commitResponse, storageManager) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            LoggerProxy.info(AbstractOfflineDataUpdater.tag, '更新已提交的离线数据, param = ', param);
                            return [4 /*yield*/, storageManager.storage.transaction([OfflineData, DocumentData], TransactionMode.READ_WRITE, function (transaction) { return __awaiter(_this, void 0, void 0, function () {
                                    var offlineDataCollection, offlineDataStorage, documentDataCollection, documentDataStorage, deletionCondition, upsertDocumentData;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                offlineDataCollection = transaction.collection(OfflineData);
                                                offlineDataStorage = new OfflineDataStorage(offlineDataCollection);
                                                documentDataCollection = transaction.collection(DocumentData);
                                                documentDataStorage = new DocumentDataStorage(documentDataCollection);
                                                deletionCondition = this.generateDeleteOfflineDataCondition(commitResponse, param);
                                                // 2. 删除本地未提交数据，这里要根据 task id 来进行删除
                                                return [4 /*yield*/, offlineDataStorage.deleteChanges(deletionCondition)];
                                            case 1:
                                                // 2. 删除本地未提交数据，这里要根据 task id 来进行删除
                                                _a.sent();
                                                return [4 /*yield*/, this.generateUpsertDocumentData(commitResponse, param)];
                                            case 2:
                                                upsertDocumentData = _a.sent();
                                                if (!(upsertDocumentData.length > 0)) return [3 /*break*/, 4];
                                                return [4 /*yield*/, documentDataStorage.upsertChanges(upsertDocumentData)];
                                            case 3:
                                                _a.sent();
                                                _a.label = 4;
                                            case 4: return [2 /*return*/];
                                        }
                                    });
                                }); })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(AbstractOfflineDataUpdater, "tag", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'AbstractOfflineDataUpdater'
    });
    return AbstractOfflineDataUpdater;
}());
export { AbstractOfflineDataUpdater };
